// extracted by mini-css-extract-plugin
export default {"containerPergunta":"InputPergunta_containerPergunta__ECaQQ","containerPerguntaInputs":"InputPergunta_containerPerguntaInputs__p0lpp","vertical":"InputPergunta_vertical__6E8fg"};